import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetOwnerParams } from '../../../spacesPlatform/utils/actionParams';

export class SetDataRolesOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setDataRolesOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
